<template>
  <div class="container con-them">
    <div class="header">
      <div class="inner">
        <div class="logo">
          <!-- <img :src="logoImage" :alt="logoTitle" @click="sy"/> -->
          <router-link :to="'/'"><img :src="logoImage" :alt="logoTitle" /></router-link>
        </div>
        <div class="srch-account">
          <div class="m-account" v-show="false">
            <router-link :to="'/Register'" class="login-pg-btn"><i class="el-icon-user"></i>Register</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="inner">
      <div class="login-page">
        <div class="lg-form">
          <div class="lg-hd">
            <div class="item pss" :class="{ active: validMode == 1 }" @click="changeValidMode(1)">Account</div>
            <div class="item mess" :class="{ active: validMode == 2 }" @click="changeValidMode(2)" v-if="loginMode == 1">
              Tel</div>
          </div>
          <div class="lg-bd">
            <div class="item l-pss active">
              <el-form :model="ruleForm" :rules="rules" ref="loginForm" class="demo-ruleForm">
                <el-form-item prop="phone">
                  <el-input :placeholder="loginMode == 1 ? 'Please Input tel' : 'Please Input account'"
                    v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <el-form-item prop="pass" v-if="validMode == 1">
                  <el-input type="password" placeholder="Please Input password" v-model="ruleForm.pass"
                    autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="code" v-if="validMode == 2">
                  <el-input placeholder="Please Input code" v-model="ruleForm.code">
                    <template slot="append">
                      <div v-if="isShow" @click="verification">get code</div>
                      <div v-if="!isShow">again<span>{{ count }}</span>s</div>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm()">Login</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="lg-ft" v-show="false">
            You don't have an account yet? Please click here <router-link :to="'/Register'">Register</router-link>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonFoot from "common/foot/Foot";
export default {
  name: "Login",
  components: {
    CommonFoot,
  },
  data: function () {
    return {
      // 登录方式 1：手机，2：账号
      loginMode: 1,
      // 验证方式 1：密码，2：短信
      validMode: 1,
      isShow: true,
      count: 0,
      msg: "",
      ruleForm: { phone: "", pass: "", code: "" },
      rules: {
        phone: [{ required: true, message: "Please Input correct phone number", pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }],
        pass: [{ required: true, pattern: /^\S{6,}$/, message: "Please Input correct password", trigger: "blur" }],
        code: [{ required: true, message: "Please Input correct code", trigger: "blur" }],
      },
      logoImage: require("@/assets/logo.png"),
      logoTitle: "BOOK KNOWLEDGE SEARCH (BKS)",
    };
  },
  async mounted() {
    await this.$onWait;
    if (this.http.GetOrgInfo().Cover) {
      this.logoImage = this.$bti.ServerUrl + this.http.GetOrgInfo().Cover;
    }
    this.loginMode = this.http.GetOrgInfo().LoginMode;
    this.logoTitle = this.http.GetOrgInfo().OrgName;
    document.title = this.logoTitle;

    if (this.loginMode == 2) {
      this.rules.phone = [{ required: true, message: "请输入正确的账号", pattern: /^\S{4,}$/, trigger: 'blur' }];
    }

    //ip范围内自动登录
    //console.log('load xxx')
  },
  methods: {
    submitForm: function () {
      this.$store.commit("saveToken", "");
      this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        var params = {
          phone: this.ruleForm.phone,
          pass: this.ruleForm.pass,
          code: this.ruleForm.code,
        };
        var url = this.$bti.GetJwtoken(null, true);
        if (this.validMode == 2) {
          url = this.$bti.CheckSmsForLogin(null, true);
        }
        this.http.postParam(url, params, "正在登录....").then((res) => {
          if (res.code != 1) {
            this.$message({ type: "error", message: res.info, showClose: true });
            return;
          }
          var token = res.token;
          this.$store.commit("saveToken", token);
          // localStorage.setItem("OrgId", this.jwt_decode(token).orgId);
          this.$notify({ type: "success", message: "欢迎你," + this.ruleForm.phone + "", duration: 3000 });
          if (this.jwt_decode(token).orgId != this.http.GetOrgInfo().OrgId) {
            console.log("用户有自己的学校，准备跳转");
            var url = this.jwt_decode(token).domain.slice(0, this.jwt_decode(token).domain.lastIndexOf(':'))
            var domain = ""
            if (url === 'http' || url === 'https') {
              domain = this.jwt_decode(token).domain
            } else {
              domain = url + ":" + this.$bti.MobilePort
            }
            window.location.href = domain + "?token=" + token;
            return;
          }
          var redirect = this.$route.query.redirect;
          this.$router.replace(redirect ? redirect : "/");
          // if (redirect) {
          //   this.$router.replace(redirect);
          // } else {
          //   this.$router.replace("/");
          // }
        });
      });
    },
    // sy(){
    //   window.location.href = '/'
    // },
    changeValidMode: function (val) {
      this.validMode = val;
      this.$refs.loginForm.clearValidate();
    },
    verification() {
      if (!this.ruleForm.phone) {
        this.$message.error("请输入手机号码");
        return;
      }
      let url = this.$bti.GetSmsForLogin(null, true);
      this.http.postParam(url, { "tel": this.ruleForm.phone }, "正在发送....").then((r) => {
        if (r.code != 1) {
          this.$message.error(r.info);
          return;
        }
        this.$message.success("短信发送成功");
        this.isShow = false;
        this.count = 60;
        var times = setInterval(() => {
          this.count--;
          if (this.count <= 0) {
            this.isShow = true;
            clearInterval(times);
          }
        }, 1000);
      });
    },
  },
};
</script>

<style lang="css" scoped>
.header {
  padding-bottom: 50px;
}

.con-them {
  background-image: linear-gradient(to bottom,
      #57a9eb 40%,
      #c6e1f8 80%,
      #ffffff 100%);
  background-image: -webkit-linear-gradient(to bottom,
      #57a9eb 40%,
      #c6e1f8 80%,
      #ffffff 100%);
  background-image: -moz-linear-gradient(to bottom,
      #57a9eb 40%,
      #c6e1f8 80%,
      #ffffff 100%);
  background-image: -o-linear-gradient(to bottom,
      #57a9eb 40%,
      #c6e1f8 80%,
      #ffffff 100%);
  background-image: -ms-linear-gradient(to bottom,
      #57a9eb 40%,
      #c6e1f8 80%,
      #ffffff 100%);
}</style>



// WEBPACK FOOTER //
// src/pages/account/Login.vue